import {
  getUserDetails,
  getUserDetailsByEntity
} from '../../common/services/index'

const initialValueState = {
  entitiesQuantity: 0,
  entitiesList: [],
  searchError: false,
  loadingList: false,
  noReturn: false
}

export default {
  namespaced: true,
  state: initialValueState,
  mutations: {
    UPDATE_ENTITY_QUANTITY(state, payload) {
      state.entitiesQuantity = payload
    },
    UPDATE_ENTITY_LIST(state, payload) {
      state.entitiesList = payload
    },
    UPDATE_LIST_ERROR(state, payload) {
      state.searchError = payload
    },
    UPDATE_LOADING(state, payload) {
      state.loadingList = payload
    },
    UPDATE_NO_RETURN(state, payload) {
      state.noReturn = payload
    },
    PREPARE_TO_CALL(state) {
      state.entitiesList = []
      state.noReturn = false
    }
  },
  getters: {
    getEntitiesQuantity(state) {
      return state.entitiesQuantity
    },
    getEntitiesList(state) {
      return state.entitiesList
    },
    getIsListLoading(state) {
      return state.loadingList
    },
    getNoReturn(state) {
      return state.noReturn
    }
  },
  actions: {
    toggleLoadingList({ commit }, visibility) {
      commit('UPDATE_LOADING', visibility)
    },
    async updateEntityQuantity({ commit }, params) {
      const data = await getUserDetails(params)
      commit('UPDATE_ENTITY_QUANTITY', data.data.entitiesQuantity)
    },
    async searchForEntity({ commit }, params) {
      const { user, entity } = params
      commit('PREPARE_TO_CALL')
      commit('UPDATE_LIST_ERROR', false)
      commit('UPDATE_NO_RETURN', false)
      try {
        const data = await getUserDetailsByEntity(user, entity)
        const entities = data.data.entities
        if (entities.length > 0) {
          commit('UPDATE_ENTITY_LIST', entities)
          commit('UPDATE_LOADING', false)
        } else {
          commit('UPDATE_NO_RETURN', true)
          commit('UPDATE_LOADING', false)
        }
      } catch (err) {
        commit('UPDATE_LIST_ERROR', true)
      }
    }
  }
}
